module.exports = __webpack_public_path__ + "static/media/web_corkboard_photo_abramoff.1a0bf969.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/web_corkboard_photo_abramoff.jpg
// module id = 493
// module chunks = 0